import { Injectable } from '@angular/core';
import { ServicesInterface } from '../interfaces/services.interface';
import { Observable } from 'rxjs/Observable';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { LibraryHelper } from '../helpers/library.helper';
import { AuthService } from '../../services/auth.service';
import { RouteInfo } from 'app/modules/shared/sidebar/models/sidebar-routes.interface';
import { AsapBaseService } from '../lib/asap-base.service';
import { SysService } from 'app/services/sys.service';

@Injectable()
export class PermissionService extends AsapBaseService {

    private resultData: any;

    constructor(
        public http: HttpClient,
        private _authService: AuthService,
        public sysService: SysService
    ) {
        super(http);
        this.basePath = "api/v21/admin";
        this.entityName = "sys";
    }



    findAll(): Promise<any> {
        return this.sysService.assets(false);
    }

    collection(id: number): Promise<any> {
        return new Promise<any>((resolve, reject) => {
            this.findAll().then(res => {
                this.resultData = res.data;

                this.setPermissionByFunctionData(id)
                    .then(response => {
                        resolve(response);
                    })
                    .catch(error => reject(error));
            });
        });
    }

    setPermissionByFunctionData(id: number): Promise<any> {
        return new Promise<any>((resolve, reject) => {
            this.findOneBy(id).then(auth => {

                auth = auth.data[0];
                auth = {
                    resource: (auth.resource === null) ? [] : auth.resource,
                    resource_sub: (auth.resource_sub === null) ? [] : auth.resource_sub,
                    resource_sub_down: (auth.resource_sub_down === null) ? [] : auth.resource_sub_down
                };


                for (const item of this.resultData) {

                    let dataFiltered = LibraryHelper.arrayColumn(auth.resource, 'tag');
                    dataFiltered = LibraryHelper.arraySearch(item.tag, dataFiltered);

                    if (dataFiltered !== false) {

                        item.enabled = auth.resource[dataFiltered.toString()].enabled;


                        for (const subItem of item.sub) {
                            subItem.enabled = false;

                            let subItemDataFiltered = LibraryHelper.arrayColumn(auth.resource_sub, 'parent');
                            subItemDataFiltered = LibraryHelper.arraySearch(item.tag, subItemDataFiltered);

                            if (subItemDataFiltered !== false) {
                                auth.resource_sub.forEach((value, index) => {
                                    if (value.tag === subItem.tag && value.parent === subItem.parent) {
                                        subItem.enabled = value.enabled;
                                    }
                                });
                            }

                        }

                    } else {
                        item.enabled = false;
                    }

                }
                resolve(this.resultData);

            }, err => reject(err));
        });
    }

    unifyAllSubItems(array: any[], level: number): any[] | boolean {
        const arr = [];

        if (!level) {
            return false;
        } else if (level === 1) {
            array.forEach(value => {
                if (value.sub && value.sub.length > 0) {
                    value.sub.forEach(vals => {
                        arr.push(vals);
                    })
                }
            });
        }
        return arr;
    }


    filterSideBar(routes: RouteInfo[], id: number): Promise<RouteInfo[]> {

        return new Promise<RouteInfo[]>((resolve, reject) => {

            this.collection(id)
                .then(response => {

                    routes = routes.filter(menuItem => {

                        if (menuItem.children && menuItem.children.length > 0) {
                            menuItem.children = menuItem.children.filter(subMenuItem => {

                                const arrCompare = this.unifyAllSubItems(response, 1);
                                const permissions2 = LibraryHelper.arrayColumn(arrCompare, 'tag');

                                const arrCheck2 = LibraryHelper.arraySearch(subMenuItem.role, permissions2);


                                if (arrCheck2 !== false) {
                                    return (arrCompare[arrCheck2].enabled);
                                } else {
                                    return false;
                                }

                            });
                        }

                        const permissions = LibraryHelper.arrayColumn(response, 'tag');

                        const arrCheck = LibraryHelper.arraySearch(menuItem.role, permissions);
                        if (arrCheck !== false) {
                            return (response[arrCheck].enabled);
                        } else {
                            return false;
                        }

                    });
                    resolve(routes);
                })
                .catch(err => reject(err));
        })
    }

    findOneBy(id: any): Promise<any> {
        // return this.http.get(environment.baseUrl + '/api/v2/admin/permission/' + id, LibraryHelper.getHeaders());
        return new Promise<any>((resolve) => {
            // sessionStorage.removeItem('permission-' + id);
            let cachedMenu = JSON.parse(sessionStorage.getItem('permission-' + id));
            if (!cachedMenu || !cachedMenu.data || cachedMenu.data.length <= 0) {
                this.http.get(environment.baseUrl + '/api/v2/admin/permission/' + id, LibraryHelper.getHeaders()).subscribe((response: any) => {
                    sessionStorage.setItem('permission-' + id, JSON.stringify(response));
                    resolve(response);
                });
            }
            else {
                resolve(cachedMenu);
            }
        });
    }

    findBy(id: number): Promise<any> {
        return undefined;
    }

    filterBy(data: any[]): Observable<any> {
        return undefined;
    }

    persist(permission: any): Observable<any> {
        let url;

        if (permission.type === 'main') {
            url = '/api/v2/admin/permission/' + permission.id + '/update';
        } else {
            url = '/api/v2/admin/permission/' + permission.id + '/sub/update';
        }

        return this.http.put(
            environment.baseUrl + url, permission.data,
            LibraryHelper.getHeaders()
        );
    }

    delete(id: number): Observable<any> {
        return undefined;
    }

    setStatus(status: number, id: number): Observable<any> {
        return undefined;
    }

}



// WEBPACK FOOTER //
// ./src/app/@core/services/permission.service.ts